/* eslint  react/jsx-no-bind:0 */
import React from "react"
import { Route } from "react-router-dom"

import { ScheduleResultsPage } from "../../components/pages/scheduleresults"
import Base from "./Base"

const IndexPage = () => (
 
  <Base>
    <Route path="/" exact component={ScheduleResultsPage} />
  </Base>
)
export default IndexPage


// WEBPACK FOOTER //
// ./src/components/layout/IndexPage.js